export const MICRO = '\xb5'
